'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = user;

var _user = require('../actions/user');

var _User = require('../models/User');

var _User2 = _interopRequireDefault(_User);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokenData = localStorage.getItem(_constants.TOKEN_DATA_STORAGE_KEY);
tokenData = tokenData ? JSON.parse(tokenData) : {};

var initialState = new _User2.default(tokenData);

function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = void 0;
    switch (action.type) {
        case _user.LOGOUT:
            return Object.assign({}, state, {
                loggedIn: false,
                refreshToken: null,
                rememberMe: false,
                token: null
            });
        case _user.GET_USER_DATA_FAIL:
            return Object.assign({}, state, {
                loggedIn: false,
                refreshToken: null,
                rememberMe: false,
                token: null
            });
        case _user.GET_USER_DATA_SUCCESS:
            action.payload.body.loggedIn = true;
            newState = new _User2.default(state);
            newState.extend(action.payload.body);
            return newState;
        case _user.UPDATE_USER:
            newState = new _User2.default(state);
            newState.extend(action.payload);
            return newState;

        case _user.USER_CHANGE_PASSWORD_SUCCESS:
            newState = new _User2.default(state);
            newState.extend(action.payload.body);
            return newState;
        default:
            return state;
    }
}
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/reducers/user.js
// module id = 1286
// module chunks = 5